var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localValue.type === 'textbox')?_c('div',{staticClass:"relative",style:('margin: ' + _vm.styles.margin.join('px ') + 'px;' +
    'color:' + _vm.styles.color + ';'),attrs:{"id":'element' + _vm.index}},[(!_vm.hideLabels)?_c('div',{staticClass:"text-sm font-semibold mb-2",style:('text-align: ' + _vm.styles.text.textAlign + ';' +
      'color: ' + _vm.styles.labelColor + ';')},[_vm._v(" "+_vm._s(_vm.localValue.placeholder)+" "),(
      _vm.localValue.mandatory === true ||
      _vm.localValue.mandatory === 1 ||
      _vm.localValue.mandatory === 'true'
      )?_c('span',{staticStyle:{"color":"red","font-weight":"bold"}},[_vm._v("*")]):_vm._e()]):_vm._e(),_c('text-input',{staticClass:"text-dark flex border-none",staticStyle:{"background":"none","height":"auto"},attrs:{"type":"text","inputStyle":'background:' + _vm.styles.backgroundColor + ';' +
      'box-shadow:' + (_vm.styles.boxShadow ?? '') + ';' +
      'padding: ' + _vm.styles.padding.join('px ') + 'px;' +

      '--form-style-placeholder-color:' + _vm.styles.placeholderColor + ';' +
      'font-family:' + (_vm.styles.text.fontFamily || '') + ';' +
      'text-shadow:' + (_vm.styles.text.textShadow || '') + ';' +
      'font-size:' + _vm.styles.text.fontSize + 'px;' +
      'text-align:' + _vm.styles.text.textAlign + ';' +
      'font-style:' + (_vm.styles.text.fontStyle || '') + ';' +
      'font-weight:' + (_vm.styles.text.fontWeight || '') + ';' +
      'letter-spacing:' + (_vm.styles.text.letterSpacing || '') + ';' +
      'line-height:' + (_vm.styles.text.lineHeight || '') + ';' +
      '-webkit-text-stroke-width:' + (_vm.styles.text.textStrokeWidth || '') + ';' +
      '-webkit-text-stroke-color:' + (_vm.styles.text.textStrokeColor || '') + ';' +
      'text-decoration-line:' + (_vm.styles.text.textDecorationLine || '') + ';' +
      'color:' + _vm.styles.text.color + ';' +

      'height:auto;' +
      'border-width:' + _vm.styles.border?.width.join('px ') + 'px;' +
      'border-radius:' + _vm.styles.border?.radius.join('px ') + 'px;' +
      'border-color:' + _vm.styles.border?.color.join(' ') + ';' +
      'border-style:' + _vm.styles.border?.style.join(' ') + ';' +
      _vm.styles.customStyles ?? '',"placeholder":_vm.localValue.placeholder}}),(
      (_vm.localValue.mandatory === true ||
      _vm.localValue.mandatory === 1 ||
      _vm.localValue.mandatory === 'true') &&
      _vm.hideLabels
    )?_c('span',{staticClass:"absolute",style:('color: #ff0000; font-weight: bold; right: 16px;' +
      'top:' + (_vm.styles.padding[0]) + 'px;' +
      (_vm.styles.text.textAlign == 'right' ?
      'left:' + (10) + 'px;' :
      'right:' + (10) + 'px;' ))},[_vm._v("*")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }